<template>
    <div class="d-flex flex-column gap-2">
        <input
            v-if="showSearch"
            :value="searchValue"
            type="search"
            class="form-control bg-dark text-white border-secondary text-xs"
            :placeholder="searchPlaceholder"
            @input="$emit('update:search-value', $event.target.value)"
        >

        <nav
            v-if="showPagination && pageCount > 1"
            class="d-flex align-items-center justify-content-between gap-2"
            :aria-label="paginationLabel"
        >
            <button
                type="button"
                class="btn btn-outline-light btn-sm rounded-3"
                :disabled="currentPage <= 1"
                @click="$emit('update:current-page', currentPage - 1)"
            >
                Previous
            </button>
            <span class="text-white-50 text-xs">Page {{ currentPage }} of {{ pageCount }}</span>
            <button
                type="button"
                class="btn btn-outline-light btn-sm rounded-3"
                :disabled="currentPage >= pageCount"
                @click="$emit('update:current-page', currentPage + 1)"
            >
                Next
            </button>
        </nav>
    </div>
</template>

<script>
export default {
    name: "SettingsMobileListControls",

    props: {
        searchValue: {
            type: String,
            default: ""
        },
        searchPlaceholder: {
            type: String,
            default: "Search"
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageCount: {
            type: Number,
            default: 1
        },
        paginationLabel: {
            type: String,
            default: "Pages"
        },
        showSearch: {
            type: Boolean,
            default: true
        },
        showPagination: {
            type: Boolean,
            default: true
        }
    },

    emits: ["update:search-value", "update:current-page"]
};
</script>
